import { Header } from '@/components/Header';
import { StyledContent, StyledLayout, StyledMainContainer } from './styles';
import { NavHeader } from '../NavHeader';

type MainLayoutProps = {
  children: React.ReactNode;
};

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <StyledLayout>
      <NavHeader />
      <StyledMainContainer>
        <Header />
        <StyledContent>{children}</StyledContent>
      </StyledMainContainer>
    </StyledLayout>
  );
}
